import React from 'react'
import { Formik } from 'formik'
import { pick } from 'lodash'
import { UseMutateCandidateByIdReturn, candidateOfferLetterByIdDocument, useMutateCandidateById, useCandidateOfferLetterById } from 'src/queries'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { MutateCandidateByIdMutation } from 'src/gql/graphql'
import Form from './Form'

type Values = Parameters<UseMutateCandidateByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const candidate = useCandidateOfferLetterById(id)
  if (candidate === undefined) {
    throw new Error('Could not load candidate!')
  }
  const update = useMutateCandidateById()
  const initialState: Values = pick(candidate, [
    'offer_letter.approved',
    'offer_letter.extended',
    'offer_letter.signed'
  ])
  const invalidateCandidate = useInvalidateQueryByDocument(candidateOfferLetterByIdDocument)
  const handleSuccess = (data: MutateCandidateByIdMutation): void => {
    const id = data.cat?.candidate?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateCandidate({ id })
    }
    toggle()
  }
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <Form toggle={toggle} isLoading={update.isLoading} hasError={update.isError} />
      )}
    </Formik>
  )
}

export default FormContext
